import styled, { css } from 'styled-components'
import { Box } from '../UI/Box'

export const LoadingHolder = styled(Box)<{ size: number }>`
  flex: 0;
  justify-content: center;
  align-items: center;
  z-index: 1;
  img {
    max-width: ${({ size }) => size}px;
    opacity: 0.8;
  }
`
